const CLIENT_SESSION_STORAGE_KEY = 'gymgpt.clientSession.v1';
export const CLIENT_SESSION_HEADER = 'X-Client-Session';

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Fallback when localStorage is unavailable (Node live tests, private browsing). */
let memorySessionId: string | null = null;

function readStoredSession(): string | null {
  try {
    const value = localStorage.getItem(CLIENT_SESSION_STORAGE_KEY);
    if (!value || !UUID_RE.test(value)) {
      return memorySessionId;
    }
    return value;
  } catch {
    return memorySessionId;
  }
}

export function getClientSessionId(): string | null {
  return readStoredSession();
}

/** Persist a client session UUID when none exists yet (required for conversation routes). */
export function ensureClientSessionId(): string {
  const existing = readStoredSession();
  if (existing) {
    return existing;
  }
  const sessionId = crypto.randomUUID();
  setClientSessionId(sessionId);
  return sessionId;
}

export function setClientSessionId(sessionId: string): void {
  if (!UUID_RE.test(sessionId)) {
    return;
  }
  memorySessionId = sessionId;
  try {
    localStorage.setItem(CLIENT_SESSION_STORAGE_KEY, sessionId);
  } catch {
    /* localStorage unavailable */
  }
}

/** Test-only: reset session state between isolated live API cases. */
export function resetClientSessionForTests(): void {
  memorySessionId = null;
  try {
    localStorage.removeItem(CLIENT_SESSION_STORAGE_KEY);
  } catch {
    /* localStorage unavailable */
  }
}

export function clientSessionHeaders(): Record<string, string> {
  return { [CLIENT_SESSION_HEADER]: ensureClientSessionId() };
}

export function rememberClientSessionFromResponse(response: Response): void {
  const sessionId = response.headers.get(CLIENT_SESSION_HEADER);
  if (sessionId) {
    setClientSessionId(sessionId);
  }
}
